import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.is-array";
import Renderer_0_2, { MOBILEDOC_VERSION as MOBILEDOC_VERSION_0_2 } from './renderers/0-2';
import Renderer_0_3, { MOBILEDOC_VERSION_0_3_0, MOBILEDOC_VERSION_0_3_1, MOBILEDOC_VERSION_0_3_2 } from './renderers/0-3';
import RENDER_TYPE from './utils/render-type';
/**
 * runtime DOM renderer
 * renders a mobiledoc to DOM
 *
 * input: mobiledoc
 * output: DOM
 */

function validateCards(cards) {
  if (!Array.isArray(cards)) {
    throw new Error('`cards` must be passed as an array');
  }

  for (var i = 0; i < cards.length; i++) {
    var card = cards[i];

    if (card.type !== RENDER_TYPE) {
      throw new Error("Card \"".concat(card.name, "\" must be of type \"").concat(RENDER_TYPE, "\", was \"").concat(card.type, "\""));
    }

    if (!card.render) {
      throw new Error("Card \"".concat(card.name, "\" must define `render`"));
    }
  }
}

function validateAtoms(atoms) {
  if (!Array.isArray(atoms)) {
    throw new Error('`atoms` must be passed as an array');
  }

  for (var i = 0; i < atoms.length; i++) {
    var atom = atoms[i];

    if (atom.type !== RENDER_TYPE) {
      throw new Error("Atom \"".concat(atom.name, "\" must be type \"").concat(RENDER_TYPE, "\", was \"").concat(atom.type, "\""));
    }

    if (!atom.render) {
      throw new Error("Atom \"".concat(atom.name, "\" must define `render`"));
    }
  }
}

var RendererFactory =
/*#__PURE__*/
function () {
  function RendererFactory() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$cards = _ref.cards,
        cards = _ref$cards === void 0 ? [] : _ref$cards,
        _ref$atoms = _ref.atoms,
        atoms = _ref$atoms === void 0 ? [] : _ref$atoms,
        _ref$cardOptions = _ref.cardOptions,
        cardOptions = _ref$cardOptions === void 0 ? {} : _ref$cardOptions,
        unknownCardHandler = _ref.unknownCardHandler,
        unknownAtomHandler = _ref.unknownAtomHandler,
        _ref$markupElementRen = _ref.markupElementRenderer,
        markupElementRenderer = _ref$markupElementRen === void 0 ? {} : _ref$markupElementRen,
        _ref$sectionElementRe = _ref.sectionElementRenderer,
        sectionElementRenderer = _ref$sectionElementRe === void 0 ? {} : _ref$sectionElementRe,
        dom = _ref.dom,
        _ref$markupSanitizer = _ref.markupSanitizer,
        markupSanitizer = _ref$markupSanitizer === void 0 ? null : _ref$markupSanitizer;

    _classCallCheck(this, RendererFactory);

    validateCards(cards);
    validateAtoms(atoms);

    if (!dom) {
      if (typeof window === 'undefined') {
        throw new Error('A `dom` option must be provided to the renderer when running without window.document');
      }

      dom = window.document;
    }

    this.options = {
      cards: cards,
      atoms: atoms,
      cardOptions: cardOptions,
      unknownCardHandler: unknownCardHandler,
      unknownAtomHandler: unknownAtomHandler,
      markupElementRenderer: markupElementRenderer,
      sectionElementRenderer: sectionElementRenderer,
      dom: dom,
      markupSanitizer: markupSanitizer
    };
  }

  _createClass(RendererFactory, [{
    key: "render",
    value: function render(mobiledoc) {
      var version = mobiledoc.version;

      switch (version) {
        case MOBILEDOC_VERSION_0_2:
        case undefined:
        case null:
          return new Renderer_0_2(mobiledoc, this.options).render();

        case MOBILEDOC_VERSION_0_3_0:
        case MOBILEDOC_VERSION_0_3_1:
        case MOBILEDOC_VERSION_0_3_2:
          return new Renderer_0_3(mobiledoc, this.options).render();

        default:
          throw new Error("Unexpected Mobiledoc version \"".concat(version, "\""));
      }
    }
  }]);

  return RendererFactory;
}();

export { RendererFactory as default };